import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  userService,
  bcpSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import controller from './vendor-resource.controller';
import directive from './vendor-resource.directive';


export default angular.module('app.components.advisory.bcp.vendorResource', [
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  userService,
  bcpSharedModelService,
])
  .directive('bcpVendorResource', directive)
  .controller('VendorResourceController', controller)
  .name;

console.log('app.components.advisory.bcp.vendorResource created');
